import { useSearch } from '@tanstack/react-router'

export const useProcessDocumentErrorPage = () => {
  const { code, description } = useSearch({
    from: '/process-document/error',
  })

  return { code, description }
}
